(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookDetailController', HandbookDetailController);

    HandbookDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Handbook', 'ProfessionalArea', 'HandbookVersion', 'CustomUser'];

    function HandbookDetailController($scope, $rootScope, $stateParams, previousState, entity, Handbook, ProfessionalArea, HandbookVersion, CustomUser) {
        var vm = this;

        vm.handbook = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:handbookUpdate', function(event, result) {
            vm.handbook = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
